import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators } from '@angular/forms';

import Cropper from 'cropperjs';

import { AlertService } from '../../services/alert.service';
import { CommunityService } from '../../services/community.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

declare var $: any;

@Component({
    selector: 'community',
    templateUrl: './community.component.html',
    styleUrls: ['./community.component.scss']
})
export class CommunityComponent implements OnInit, OnDestroy {

    newPostView!: boolean;

    newMessageFormGroup!: FormGroup;

    newMessageSelectedFile!: File | null;

    imagePreviewDataURL: any = '';

    imageCroppedDataURL: any = '';

    cropper!: Cropper | null;

    filterFormGroup!: FormGroup;

    messages: any[] = [];

    count: number = 0;

    browseBeforeInProgress!: boolean;

    modalMessage: any;

    modalPhoto!: string | null;

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private communityService: CommunityService,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit() {
        this.newMessageFormGroup = this.formBuilder.group({
            newMessageTextArea: [null, /*Validators.required*/],
            newMessageFileInput: [null, /*Validators.required*/]
        });
        this.filterFormGroup = this.formBuilder.group({
            deletedNoCheckbox: [true, /*Validators.required*/],
            deletedYesCheckbox: [false, /*Validators.required*/],
            inappropriateUndefinedCheckbox: [true, /*Validators.required*/],
            inappropriateNoCheckbox: [true, /*Validators.required*/],
            inappropriateYesCheckbox: [false, /*Validators.required*/]
        });
        this.refresh();
    }

    ngOnDestroy() {
    }

    updateUser(user: any) {
        for (let message of this.messages) {
            if (message.user.id == user.id) {
                message.user.banned = user.banned;
            }
        }
    }

    postNewMessage() {
        let formGroup: FormGroup = this.newMessageFormGroup;
        let text: string = formGroup.value.newMessageTextArea;
        if (this.cropper == null && text != null) {
            this.progressIndicatorService.progress = true;
            this.communityService.postMessage(text).subscribe({
                next: (value: any) => {
                    console.log('CommunityComponent.postNewMessage.communityService.postMessage.value', value);
                    this.progressIndicatorService.progress = false;
                    this.alertService.success('Success');
                    this.cancelNewMessage();
                    this.refresh();
                },
                error: (error: any) => {
                    console.log('CommunityComponent.postNewMessage.communityService.postMessage.error', error);
                    this.progressIndicatorService.progress = false;
                    this.alertService.danger('Error');
                }
            });
        } else if (this.cropper != null) {
            this.cropper.getCroppedCanvas().toBlob((blob) => {
                this.progressIndicatorService.progress = true;
                this.communityService.postMessageWithFile(text, blob).subscribe({
                    next: (value: any) => {
                        console.log('CommunityComponent.postNewMessage.communityService.postMessageWithFile.value', value);
                        this.progressIndicatorService.progress = false;
                        this.alertService.success('Success');
                        this.cancelNewMessage();
                        this.refresh();
                    },
                    error: (error: any) => {
                        console.log('CommunityComponent.postNewMessage.communityService.postMessageWithFile.error', error);
                        this.progressIndicatorService.progress = false;
                        this.alertService.danger('Error');
                    }
                });
            }, 'image/jpeg');
        }
    }

    cancelNewMessage() {
        this.newPostView = false;
        this.newMessageFormGroup.reset();
        this.newMessageSelectedFile = null;
        this.imagePreviewDataURL = null;
        this.imageCroppedDataURL = null;
        if (this.cropper) {
            // this.cropper.destroy();
            this.cropper = null;
        }
    }

    newMessageFileInputChange(event: any) {
        let file: File = event.target.files[0];
        this.newMessageSelectedFile = file;
        this.imagePreviewDataURL = null;
        this.imageCroppedDataURL = null;
        if (this.cropper) {
            this.cropper.destroy();
            this.cropper = null;
        }
        var reader = new FileReader();
        reader.addEventListener('load', () => {
            this.imagePreviewDataURL = reader.result;
            setTimeout(() => {
                let imagePreview: any = document.getElementById('imagePreview');
                this.cropper = new Cropper(imagePreview, {
                    aspectRatio: 16 / 9,
                    autoCropArea: 1.0,
                    viewMode: 2,
                    ready: () => {
                        this.imageCroppedDataURL = this.cropper?.getCroppedCanvas().toDataURL();
                    },
                    cropend: () => {
                        this.imageCroppedDataURL = this.cropper?.getCroppedCanvas().toDataURL();
                    }
                });
            }, 0);
        }, false);
        reader.readAsDataURL(file);
    }

    refresh() {
        this.messages = [];
        this.count = 0;
        this.browseMessages();
    }

    get filteredMessages() {
        let deletedValues: any[] = [];
        let inappropriateValues: any[] = [];
        let formGroup: FormGroup = this.filterFormGroup;
        if (formGroup.value.deletedNoCheckbox === true) deletedValues.push(false);
        if (formGroup.value.deletedYesCheckbox === true) deletedValues.push(true);
        if (formGroup.value.inappropriateUndefinedCheckbox === true) inappropriateValues.push(undefined, null);
        if (formGroup.value.inappropriateNoCheckbox === true) inappropriateValues.push(false);
        if (formGroup.value.inappropriateYesCheckbox === true) inappropriateValues.push(true);
        if (deletedValues.length == 0) deletedValues.push(false, true);
        if (inappropriateValues.length == 0) inappropriateValues.push(undefined, null, false, true);
        return this.messages.filter(message => deletedValues.includes(message.deleted) && inappropriateValues.includes(message.inappropriate));
    }

    browseMessages() {
        this.progressIndicatorService.progress = true;
        this.communityService.browseMessages().subscribe({
            next: (value: any) => {
                console.log('CommunityComponent.browseMessages.communityService.browseMessages.value', value);
                this.progressIndicatorService.progress = false;
                this.messages.push(...value.data);
                this.count = value.count - value.data.length;
                setTimeout(() => this.autoBrowseBefore(), 0);
            },
            error: (error: any) => {
                console.log('CommunityComponent.browseMessages.communityService.browseMessages.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    browseBefore() {
        if (this.messages.length > 0) {
            let messageId = this.messages[this.messages.length - 1].id;
            this.browseBeforeInProgress = true;
            this.communityService.browseMessages(messageId).subscribe({
                next: (value: any) => {
                    console.log('CommunityComponent.browseBefore.communityService.browseMessages.value', value);
                    this.browseBeforeInProgress = false;
                    this.messages.push(...value.data);
                    this.count = value.count - value.data.length;
                    setTimeout(() => this.autoBrowseBefore(), 0);
                },
                error: (error: any) => {
                    console.log('CommunityComponent.browseBefore.communityService.browseMessages.error', error);
                    this.browseBeforeInProgress = false;
                    this.alertService.danger('Error');
                }
            });
        }
    }

    @HostListener('window:scroll', [])
    autoBrowseBefore() {
        if (this.count > 0 && !this.browseBeforeInProgress && !this.newPostView) {
            let documentHeight: number = $(document).height();
            let windowheight: number = $(window).height();
            let scrollTop: number = $(window).scrollTop();
            if (documentHeight - scrollTop < windowheight * 3) {
                this.browseBefore();
            }
        }
    }
}
